export const hybridLoginDefaults = {
  ssoEnabledSetting: 'NexBase.ExternalIdentityProviders.EntraId.Enabled',
  ssoProvider: 'EntraId',
  ssoLabel: 'NexBase::Title:HybridLogin:MicrosoftEntraId',
  ssoDividerLabel: 'NexBase::Title:HybridLogin:OrSignInWith',
  defaultReturnUrl: '/',
  authorizationEndpointPath: '/connect/authorize',
  passwordGrant: 'password',
  rememberMeStorageKey: 'remember_me',
} as const;

export const hybridLoginErrorQueryParams = {
  externalLoginError: 'external_login_error',
} as const;

export const hybridLoginErrorCodes = {
  externalLoginFailed: 'ExternalLogin:ExternalLoginFailed',
  missingExternalLoginCookie: 'ExternalLogin:MissingExternalLoginCookie',
  unexpectedProvider: 'ExternalLogin:UnexpectedProvider',
  missingProviderKey: 'ExternalLogin:MissingProviderKey',
  missingEmailClaim: 'ExternalLogin:MissingEmailClaim',
  unknownApplicationUser: 'ExternalLogin:UnknownApplicationUser',
  applicationEmailMismatch: 'ExternalLogin:ApplicationEmailMismatch',
  missingAumPersonOrCompany: 'ExternalLogin:MissingAumPersonOrCompany',
  inactiveOrNotYetValidUser: 'ExternalLogin:InactiveOrNotYetValidUser',
  aumEmailMismatch: 'ExternalLogin:AumEmailMismatch',
  externalLoginLinkFailed: 'ExternalLogin:ExternalLoginLinkFailed',
  lockedOutUser: 'ExternalLogin:LockedOutUser',
  externalLoginSignInFailed: 'ExternalLogin:ExternalLoginSignInFailed',
  microsoftAuthenticationFailed: 'ExternalLogin:MicrosoftAuthenticationFailed',
  microsoftRemoteAuthenticationFailed: 'ExternalLogin:MicrosoftRemoteAuthenticationFailed',
  foreignTenant: 'ExternalLogin:ForeignTenant',
  missingIdentityEmailClaim: 'ExternalLogin:MissingIdentityEmailClaim',
  unhandledCallbackException: 'ExternalLogin:UnhandledCallbackException',
  invalidReturnUrl: 'ExternalLogin:InvalidReturnUrl',
  unsupportedProvider: 'ExternalLogin:UnsupportedProvider',
  providerNotConfigured: 'ExternalLogin:ProviderNotConfigured',
} as const;

export const hybridLoginErrorLocalizationPrefix = 'NexBase::';

export const hybridLoginErrorCodeSet = new Set<string>(Object.values(hybridLoginErrorCodes));
